import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { PublicLayout } from "@/components/PublicLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import AgeGroups from "@/pages/AgeGroups";
import Coaches from "@/pages/Coaches";
import Staff from "@/pages/Staff";
import Sponsors from "@/pages/Sponsors";
import Gallery from "@/pages/Gallery";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Contact from "@/pages/Contact";
import Join from "@/pages/Join";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import RugbyNexus from "@/pages/RugbyNexus";
import UntamedGear from "@/pages/UntamedGear";
import SocialMedia from "@/pages/SocialMedia";
import AdminApp from "@/admin/AdminApp";

const Public = ({ children }) => <PublicLayout>{children}</PublicLayout>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors />
            <Routes>
              <Route path="/" element={<Public><Home /></Public>} />
              <Route path="/about" element={<Public><About /></Public>} />
              <Route path="/age-groups" element={<Public><AgeGroups /></Public>} />
              <Route path="/coaches" element={<Public><Coaches /></Public>} />
              <Route path="/staff" element={<Public><Staff /></Public>} />
              <Route path="/sponsors" element={<Public><Sponsors /></Public>} />
              <Route path="/gallery" element={<Public><Gallery /></Public>} />
              <Route path="/news" element={<Public><News /></Public>} />
              <Route path="/news/:slug" element={<Public><NewsDetail /></Public>} />
              <Route path="/contact" element={<Public><Contact /></Public>} />
              <Route path="/join" element={<Public><Join /></Public>} />
              <Route path="/privacy" element={<Public><Privacy /></Public>} />
              <Route path="/terms" element={<Public><Terms /></Public>} />
              <Route path="/rugby-nexus" element={<Public><RugbyNexus /></Public>} />
              <Route path="/untamed-gear" element={<Public><UntamedGear /></Public>} />
              <Route path="/social-media" element={<Public><SocialMedia /></Public>} />
              <Route path="/admin/*" element={<AdminApp />} />
            </Routes>
          </BrowserRouter>
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
